<template>
  <section class="about-intro">
    <div class="container">
      <div class="intro-grid">
        <div class="video-outer">
          <div class="video-wrapper" ref="videoWrapper">
            <video
              ref="video"
              class="intro-video"
              muted
              loop
              autoplay
              playsinline
              preload="none"
              :poster="videoPoster"
            >
              <source :src="videoSrc" type="video/mp4" />
            </video>
            <div class="video-badge">ABR® HARDWARE • YOLEE® SERVICE</div>
          </div>
        </div>

        <div class="text-wrapper" data-aos="fade-left">
          <h2 class="intro-title">{{ introContent.title }}</h2>
          <h3 class="intro-subtitle">{{ introContent.subtitle }}</h3>
          <p class="intro-text" v-html="introContent.text1"></p>
          <p class="intro-text" v-html="introContent.text2"></p>

          <div class="brand-visit" v-if="yoleeRole.brandLink">
            <p class="visit-text">
              {{ yoleeRole.brandLink.text }}
              <a :href="yoleeRole.brandLink.url" target="_blank" class="brand-url">
                {{ yoleeRole.brandLink.label }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { aboutAssets, aboutContent } from "@/config/about";

export default {
  name: "AboutIntro",
  data() {
    return { windowWidth: window.innerWidth, observer: null };
  },
  computed: {
    isMobile() { return this.windowWidth <= 768; },
    introContent() { return aboutContent.intro; },
    yoleeRole() { return aboutContent.yoleeRole; },
    videoSrc() { return this.isMobile ? aboutAssets.introVideo.mobile : aboutAssets.introVideo.desktop; },
    videoPoster() { return this.isMobile ? aboutAssets.introVideo.posterMobile : aboutAssets.introVideo.posterDesktop; },
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.initObserver();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    onResize() { this.windowWidth = window.innerWidth; },
    initObserver() {
      const video = this.$refs.video;
      if (!video) return;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) { video.play().catch(() => {}); } 
          else { video.pause(); }
        });
      }, { threshold: 0.3 });
      this.observer.observe(this.$refs.videoWrapper);
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";

.about-intro {
  padding: 70px 0; // 恢复原来的上下间距即可
  background: #fff;
}

/* 核心修改：新增 text-wrapper 的样式 */
.text-wrapper {
  // 桌面端：给文字右边加间距，防止贴着 1200px 的容器边缘
  padding-right: 60px; 

  @media (max-width: 768px) {
    // 移动端：左右都加内边距，解决“两边都靠边”的问题
    padding: 0 20px; 
  }
}

.intro-grid {
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 50px;
  align-items: center;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
}

.video-wrapper {
  position: relative;
  width: 100%;
  /* 桌面端保持 16:9，如果桌面端也是竖版视频，可以改为 auto 或 3 / 4 */
  aspect-ratio: 16 / 9; 
  border-radius: 2px;
  overflow: hidden;
  border: 1px solid #eee;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.06);

  @media (max-width: 768px) {
    /* 核心修改：移动端自动适应竖版比例（例如 3:4 或 9:16） */
    aspect-ratio: 3 / 4; 
    max-height: 70vh; /* 防止视频过长超出屏幕 */
  }
}

.intro-video {
  width: 100%;
  height: 100%;
  /* 确保视频内容在容器内完整铺满或留白 */
  /* 如果想看到全部画面不被裁剪，用 contain；想铺满容器用 cover */
  object-fit: cover; 
}

.video-badge {
  position: absolute;
  top: 15px;
  right: 15px;
  background: @color-primary;
  color: #fff;
  padding: 4px 10px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1px;
}

.intro-title { font-size: 36px; font-weight: 800; margin-bottom: 15px; color: @color-text-title; }

.intro-subtitle {
  font-size: 18px;
  font-weight: 700;
  color: @color-primary;
  margin-bottom: 25px;
  padding-left: 15px;
  border-left: 3px solid @color-primary;
}

.intro-text {
  font-size: 15px;
  line-height: 1.8;
  color: @color-text-sub;
  margin-bottom: 20px;
  :deep(strong) { color: @color-text-title; font-weight: 700; }
}

.brand-visit {
  margin-top: 30px;
  padding: 18px;
  background: #f7f9f8;
  border: 1px solid #edf1ef;
  .visit-text { font-size: 14px; margin: 0; color: @color-text-sub; }
  .brand-url { 
    display: inline-block;
    margin-top: 5px;
    color: @color-primary; 
    font-weight: 700; 
    text-decoration: none; 
    font-size: 16px;
    &:hover { text-decoration: underline; } 
  }
}
</style>